import { useContext } from 'react';
import { OnStartWarningHook } from '../../../../_Common/Const/Rutiner';
import AnvandarInstallningarQuery from '../Queries/FarAttesteraQuery.gql';
import {
  FarAttesteraQuery,
  FarAttesteraQueryVariables,
} from '../Queries/_QueryTypes/FarAttesteraQuery';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

export const useFakturaDelOnStartWarningHook: OnStartWarningHook =
  isLoggedIn => {
    const activeDatabase = useContext(ActiveDatabaseContext);
    const { data, loading } = useQuery<
      FarAttesteraQuery,
      FarAttesteraQueryVariables
    >(AnvandarInstallningarQuery, {
      fetchPolicy: 'cache-and-network',
      variables: {
        dbname: activeDatabase.activeDatabase || '',
      },
      skip: !activeDatabase.activeDatabase || !isLoggedIn,
    });

    return {
      loading: loading,
      ok: !loading && Boolean(data?.me?.[0]?.farAttestera?.result),
      warningText: data?.me?.[0]?.farAttestera?.message || '',
    };
  };
